import * as vp from 'vopay';

import { createContext, ReactNode, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useFetchBillingPackagesDetails, useFetchBillingSettingsDetails } from '../hooks';

export const BillingDetailsContext = createContext<vp.SettingsGroups>({});

export const BillingDetailsProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const { resource, id } = useParams<{ resource: string; id: string }>();

  const [{ packageDetails }, getPackageDetails] = useFetchBillingPackagesDetails({});
  const [{ settingsDetails }, getSettingsDetails] = useFetchBillingSettingsDetails({});

  useEffect(() => {
    const handlers: { [resource: string]: () => void } = {
      package: () => getPackageDetails(id),
      settings: () => getSettingsDetails(id),
      default: () => {},
    };

    const handler = handlers[resource] || handlers.default;

    handler();
  }, []);

  function getBillingDetails(): vp.SettingsGroups {
    const handlers: { [resource: string]: vp.SettingsGroups } = {
      package: packageDetails,
      settings: settingsDetails,
      default: {},
    };

    return handlers[resource] || handlers.default;
  }

  return <BillingDetailsContext.Provider value={getBillingDetails()}>{children}</BillingDetailsContext.Provider>;
};
